import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ClickOutsideDirective } from 'app/shared/directives/click-outside.directive';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { HelperService } from 'app/shared/services/helper.service';
import { debounceTime, distinctUntilChanged, Subject, take, takeUntil } from 'rxjs';
import { CaseFormService } from 'app/case-form/case-form.service';


@Component({
  selector: 'app-create-case-popup',
  standalone: true,
  imports: [ClickOutsideDirective, RouterModule, ReactiveFormsModule, CommonModule, TranslateModule],
  templateUrl: './create-case-popup.component.html',
  styleUrl: './create-case-popup.component.scss'
})
export class CreateCasePopupComponent {

  @Input() sidebar: boolean = false;
  @Input() sidebarExpanded: boolean = false;
  @Output() onClosePopup = new EventEmitter<void>();

  searchInput$ = new Subject<string>();
  private unsubscribe$ = new Subject<void>();

  serialObjectsList: any[] = [];
  serialSearchTried!: boolean;
  
  form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private helperService: HelperService,
    private caseFormService: CaseFormService
  ) {
    this.form = this.fb.group({
      serialNumber: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.searchInput$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(() => {
        this.getFormDataBySerialNumber(this.form.get('serialNumber')?.value);
      });
  }

  closePopup() {
    this.onClosePopup.emit();
  }

  navigateTo(url: string, serialNumberFromItem?: any) {
    const serialNumber: string = serialNumberFromItem ? serialNumberFromItem.serialNumber : undefined;
    this.onClosePopup.emit();
    this.helperService.collapsedSidebarEmiter.emit(true);
    if(serialNumber) {
      this.caseFormService.selectedSerialForm = serialNumberFromItem;
    }
    this.router.navigate([url]);
  }

  searchForSerialNumbers(serialTerm: string) {
    if (!serialTerm || serialTerm?.length < 3) {
      return;
    }

    this.searchInput$.next(serialTerm);
  }

  getFormDataBySerialNumber(serialTerm: string) {
    this.caseFormService.getCaseDataBySerialNumber(serialTerm).pipe(take(1)).subscribe((res: any) => {
      this.serialSearchTried = true;
      this.serialObjectsList = res;
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next(undefined);
    this.unsubscribe$.complete();
  }
}
